import script from "./BillTotals.vue?vue&type=script&setup=true&lang=js"
export * from "./BillTotals.vue?vue&type=script&setup=true&lang=js"

import "./BillTotals.vue?vue&type=style&index=0&id=c81bc27e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c81bc27e"]])

export default __exports__